








































































































































import { Vue, Component } from "vue-property-decorator";
import { reaction } from "mobx";
import { Observer } from "mobx-vue";
import CollectionEventDetailsDialog from "@/components/CollectionEvents/CollectionEventDetailsDialog.vue";
import collectionIssueEditDialog from "@/components/CollectionIssueEvents/CollectionIssueEditDialog.vue";
import GenerateLettersForm from "@/components/Letters/GenerateLettersForm.vue";
import { CollectionIssueEventModel } from "@/api/CollectionIssueHistory/models";
import reportStore from "@/store/reportsStore";
import collectionIssueEditStore from "@/store/collectionIssueEditStore";
import CollectionIssueLetterHistoryEditStore from "@/store/collectionIssueLetterHistoryEditStore";
import notificationStore from "@/store/notificationStore";
import CollectionIssueLetterHistoryEditDialog from "@/components/CollectionIssueEvents/CollectionIssueLetterHistoryEditDialog.vue";
import { dateExact, datetimeExact } from "@/filters/DateExact";

@Observer
@Component({ components: { CollectionEventDetailsDialog, GenerateLettersForm, collectionIssueEditDialog, CollectionIssueLetterHistoryEditDialog } })
class ReportResults extends Vue {
  isDetailsDialogOpen = false;
  selected: CollectionIssueEventModel | null = null;
  reportStore = reportStore;
  collectionIssueEditStore = collectionIssueEditStore;
  collectionIssueEditDialogOpen = false;
  collectionIssueLetterHistoryDialogOpen = false;

  dispose?: () => void;

  mounted() {
    const collectionIssueEditDialogOpenHandler = reaction(
      () => this.collectionIssueEditStore.collectionIssueEditDialogOpen,
      () => {
        this.collectionIssueEditDialogOpen = this.collectionIssueEditStore.collectionIssueEditDialogOpen;
      },
      { fireImmediately: true }
    );

    const collectionIssueLetterHistoryEditDialogOpenHandler = reaction(
      () => this.collectionIssueEditStore.collectionIssueLetterHistoryDialogOpen,
      () => {
        this.collectionIssueLetterHistoryDialogOpen = this.collectionIssueEditStore.collectionIssueLetterHistoryDialogOpen;
      },
      { fireImmediately: true }
    );

    this.dispose = () => {
      collectionIssueEditDialogOpenHandler();
      collectionIssueLetterHistoryEditDialogOpenHandler();
    };
  }

  showDetailsDialog(item: CollectionIssueEventModel) {
    this.selected = item;
    this.isDetailsDialogOpen = true;
  }

  showEditDialog(item: CollectionIssueEventModel) {
    collectionIssueEditStore.collectionIssueSelected = item;
    this.showCollectionIssueEditDialog();
  }

  handleCollectionIssueLetterHistoryEditDialogShow() {
    collectionIssueEditStore.collectionIssueEditDialogOpen = false;
    collectionIssueEditStore.collectionIssueLetterHistoryDialogOpen = true;
  }

  showCollectionIssueEditDialog() {
    collectionIssueEditStore.collectionIssueEditDialogOpen = true;
    collectionIssueEditStore.collectionIssueLetterHistoryDialogOpen = false;
  }

  async handleUpdateCollectionIssue() {
    try {
      await collectionIssueEditStore.UpdateCollectionIssue();
      await reportStore.fetchReportSearch();
      notificationStore.success("Collection Issue Updated");
    } catch (error) {
      notificationStore.error("An unexpected error occurred while updating collection issue. Please try again later or contact support.");
    }
  }

  async handleLetterHistoryDeleted() {
    await reportStore.fetchReportSearch();
  }

  async handleDeleteSelectedLetterHistory() {
    try {
      if (confirm("Are you sure you want to delete the letter history?")) {
        if (CollectionIssueLetterHistoryEditStore.selectedLetterHistory) {
          CollectionIssueLetterHistoryEditStore.letterHistory = CollectionIssueLetterHistoryEditStore.letterHistory.filter(
            item => item.id !== CollectionIssueLetterHistoryEditStore.selectedLetterHistory?.id
          );
        }

        await CollectionIssueLetterHistoryEditStore.DeleteSelectedHistory();
        notificationStore.success("Letter History Deleted");
      }
    } catch (error) {
      notificationStore.error("An unexpected error occurred while deleting letter history. Please try again later or contact support.");
    }
  }

  resetSelectedRows() {
    this.reportStore.selectedResults = [];
  }

  destroyed() {
    if (this.dispose) this.dispose();
  }

  formatDate(date: string | Date | undefined) {
    if (!date) return "";
    const iso = date instanceof Date ? date.toISOString() : date;
    return dateExact(iso);
  }

  formatDatetime(value: string | Date): string {
    if (!value) return "";
    // Use Luxon filter for consistent formatting
    if (typeof value === "string") {
      return datetimeExact(value);
    }
    // If value is Date, convert to ISO string
    return datetimeExact(value.toISOString());
  }
}

export default ReportResults;
